import { render, staticRenderFns } from "./AddressManagement.vue?vue&type=template&id=9bb0d8d6&scoped=true"
import script from "./AddressManagement.vue?vue&type=script&lang=js"
export * from "./AddressManagement.vue?vue&type=script&lang=js"
import style0 from "./AddressManagement.vue?vue&type=style&index=0&id=9bb0d8d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb0d8d6",
  null
  
)

export default component.exports